import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { Loading } from '@/components/Loading'
import { Note } from '@/components/Note'
import { Steps } from '@/components/Steps'
import { WizzardHeader } from '@/components/WizzardHeader'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useMeetingRecord } from '@/context/MeetingRecordProvider'
import { useSelectedOffersAddonContext } from '@/context/SelectedOffersAddonProvider'
import { useGetInsurances } from '@/hooks/useInsuranceParams'
import { useGetAvailableAddonOffers } from '@/hooks/useOfferAddon'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'

import { StepComplete } from '.'

export const StepCompleteWrapper = () => {
  const navigate = useNavigate()
  const [noteText, setNoteText] = useState<string | undefined>(undefined)

  const [isLoading, setIsLoading] = useState(true)

  const {
    insuranceParamsId: paramsId,
    isContracted,
  } = useInsuranceParams()
  const {
    addonOffers,
    isLoadingData,
    refetch: refetchAddonOffers,
  } = useSelectedOffersAddonContext()

  const {
    mutateAsync: getAvailableAddonOffers,
    data: dataAvailableAddonOffers,
    isPending: isLoadingGetOffers,
  } = useGetAvailableAddonOffers()
  const availableAddonOffers = dataAvailableAddonOffers?.data ?? []

  useEffect(() => {
    refetchAddonOffers({})
    getAvailableAddonOffers({ paramsId: paramsId! })
  }, [])

  const { refetch, meetingRecord } = useMeetingRecord()

  const getResultsEnabled = (addonOffers?.length ?? 0) > 0
  const results = useGetInsurances(addonOffers?.map((x) => x.offerId) ?? [])

  const allResultsLoaded =
    results.filter((x) => !x.isLoading && x.isFetched).length ==
    addonOffers.length && getResultsEnabled
  useEffect(() => {
    if (
      allResultsLoaded &&
      meetingRecord &&
      availableAddonOffers.length > 0 &&
      !isLoadingData
    )
      setIsLoading(false)
  }, [allResultsLoaded, meetingRecord, availableAddonOffers.length, isLoadingData])

  useEffect(() => {
    if (!isContracted) {
      navigate(`/extra/steps/4/${paramsId}`)
      return
    } else {
      refetch()
    }
  }, [])

  useEffect(() => {
    results.forEach((r) => r.refetch())
  }, [isContracted, addonOffers])

  return (
    <PageWrapper
      header={<WizzardHeader />}
      steps={<Steps />}
      sidebar={<Sidebar />}
      contentProps={{
        sx: {
          pt: { base: 0, md: 0 },
        },
      }}
    >
      {noteText && noteText !== '' && (
        <Note
          date="11.10.2021 14:35"
          text={noteText}
          onChange={(text) => setNoteText(text)}
        />
      )}

      <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
        {isLoading && <Loading large={true} />}

        {!isLoading && !isLoadingGetOffers && !!meetingRecord && isContracted && (
          <StepComplete />
        )}
      </Box>
    </PageWrapper>
  )
}
